/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
import { useSelector, useDispatch } from "react-redux";
import Transaction from "../components/ListItems/Transaction";
import { TransactionAllocation, BudgetItem, CurrentUser, FamilyFeatureValue, FamilyHasAccess, TransactionItem } from "../types";
import { useItems } from "../features/Fetch/Items";
import { Grid } from "@mui/material";
import { ExclamationCircle } from "react-bootstrap-icons";
import { ModalProps, setProps } from "../features/Slices/modalSlice";
import { useNavigate } from "react-router-dom";
import ApproveTransaction from "../components/Modals/ApproveTransaction";
import { Features } from "../constants";
import CheckRequest from "../components/ListItems/CheckRequest";
import Divider from "../components/Inputs/Divider";
import ApproveCheckRequest from "../components/Modals/ApproveCheckRequest";

const Approval = (props: any) => {
	const repo = useItems();
	const user: CurrentUser = useSelector((state: any) => state.userData.value);

	const dispatch = useDispatch();
	const modal: ModalProps = useSelector((state: any) => state.modal.value);

	const budgets: BudgetItem[] = repo.GetBudgetTree(useSelector((state: any) => state.budgets.value));
	const navigate = useNavigate();

	let transactions: TransactionItem[] | null = repo.SortedTransactions(null);
	transactions = transactions?.filter(t => t.needsMyApproval) ?? [] as TransactionItem[];
	let checkRequests = useSelector((state: any) => state.checkRequests.value) as TransactionItem[];
	checkRequests = checkRequests?.filter(t => t.needsMyApproval || t.checkRequest!.needsMyApproval) ?? [] as TransactionItem[];

	if (!FamilyHasAccess(user, Features.Transactions)) {
		navigate("/");
		return <></>;
	}

	return (
		<>
			<Grid container rowSpacing={3} justifyContent="center" className="">
				<Grid item xs={2}>
				</Grid>
				<Grid item xs={6}>
					<h2 className="mt-2 text-app">Approvals</h2>
				</Grid>
				<Grid item xs={3}>
				</Grid>
						{transactions.length === 0 && checkRequests.length === 0 && (
							<Grid container onClick={GoHome} className="cursor-pointer">
								<Grid item xs={2}>
									<ExclamationCircle />
								</Grid>
								<Grid item xs={10}>
									There are no more approvals. Click here to return to {FamilyFeatureValue(user, Features.TransactionTitle)}s.
								</Grid>
							</Grid>
						)}
						{(transactions.length > 0 || checkRequests.length > 0) && (

							<Grid container>
								<>
									{checkRequests.length > 0 && <h4 className="centered mt-3 text-app">Check Requests</h4>}
									{
										checkRequests.map(transaction => {
											return (
												<div className="w-100" key={`crdiv${transaction.checkRequest!.accountTransactionCheckRequestId}`}>
													<CheckRequest
														Item={transaction}
														OnClick={() => transaction.checkRequest!.approvalState === 1 ? OpenFinalCrModal(transaction.checkRequest!.accountTransactionCheckRequestId) : OpenCrModal(transaction.checkRequest!.accountTransactionCheckRequestId)}
														key={`dr${transaction.checkRequest!.accountTransactionCheckRequestId}`} />
												</div>
											);
										})
									}
									{checkRequests.length > 0 && transactions.length > 0 && <Divider />}
									{transactions.length > 0 && <h4 className="centered mt-3 text-app">{FamilyFeatureValue(user, Features.TransactionTitle)}s</h4>}
									{
										transactions.map(transaction => {
											return (
												<div className="w-100" key={`transactdiv${transaction.accountTransactionId}`}>
													<Transaction
														Item={transaction}
														Color={transaction.color}
														OnClick={() => OpenModal(transaction.accountTransactionId)}
														key={`transaction${transaction.accountTransactionId}`} />
												</div>
											);
										})
									}
								</>
							</Grid>
						)}
			</Grid>
		</>
	);

	function HideModal() {
		dispatch(setProps({ ...modal, IsOpen: false }));
	}

	function GoHome() {
		navigate("/");
	}

	function SaveTransaction(item: TransactionItem) {
		repo.ApproveTransactionAsync(item);
		HideModal();
		repo.GetTransactionsAsync(-1);
	}

	function SaveCheckRequest(item: TransactionItem) {
		item.needsMyApproval = false;
		repo.ApproveCheckRequestAsync(item);
		HideModal();
		repo.GetCheckRequestsAsync();
	}

	function OpenModal(idx: number) {
		const transaction = { ...transactions!.find(t => t.accountTransactionId === idx) } as TransactionItem;
		if (transaction) transaction.allocations = transaction.allocations!.map<TransactionAllocation>((b: TransactionAllocation) => {
			return {
				...b
			};
		});
		if (transaction) {
			const newModal = {
				...modal,
				Body: <ApproveTransaction Mileage={transaction.miles != null} Transaction={transaction} Budgets={budgets} OnSave={SaveTransaction} Close={HideModal} />,
				IsOpen: true,
				WasOpen: false
			};
			dispatch(setProps(newModal));
		}
	}

	function OpenCrModal(idx: number) {
		const transaction = checkRequests.find(t => t.checkRequest!.accountTransactionCheckRequestId === idx);
		if (transaction) {
			const newModal = {
				...modal,
				Body: <ApproveCheckRequest Transaction={transaction} Budgets={budgets} Approve="Approve" Reject="Reject" ApproveValue={1} OnSave={SaveCheckRequest} Close={HideModal} />,
				IsOpen: true,
				WasOpen: false
			};
			dispatch(setProps(newModal));
		}
	}

	function OpenFinalCrModal(idx: number) {
		const transaction = checkRequests.find(t => t.checkRequest!.accountTransactionCheckRequestId === idx);
		if (transaction) {
			const newModal = {
				...modal,
				Body: <ApproveCheckRequest Transaction={transaction} Budgets={budgets} Approve="Check Complete" Reject="Send Back to Requester" ApproveValue={2} OnSave={SaveCheckRequest} Close={HideModal} />,
				IsOpen: true,
				WasOpen: false
			};
			dispatch(setProps(newModal));
		}
	}
}

export default Approval;